import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/pigments',
    name: 'POST_PIGMENTS',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
